export default {
    "openingScreen": {
    "message": "다음을 플레이하고 CrxMouse 사용 방법 알아보기",
        "description": "Start game screen. Sentence finishes with the words - The Mouse Chase"
},
    "startGame": {
    "message": "게임 시작",
        "description": "Start game option - on screen 1"
},
    "settings": {
    "message": "CrxMouse 설정",
        "description": "Settings option. Don't translate the word - CrxMouse - on screen 1 and 6"
},
    "gestureList": {
    "message": "제스처 목록",
        "description": "Gesture list option - on screen 1 and 6"
},
    "playLater": {
    "message": "나중에 플레이",
        "description": "Play later option - on screen 1"
},
    "playAgain": {
    "message": "다시 플레이",
        "description": "Play again option - on screen 6"
},
    "startGameScreen0": {
    "message": "게임 시작하기",
        "description": "First sentence of the first screen for users that don't have CrxMouse installed - on screen 0"
},
    "firstGestureInstructionDownload": {
    "message": "Chrome에서 CrxMouse 다운로드",
        "description": "CrxMouse is available on Chrome extension store. This is the CTA that sends the user to CrxMouse on Chrome. Do not translate the word - CrxMouse - on screen 0"
},
    "firstDownloadNow": {
    "message": "지금 다운로드",
        "description": "CTA to download CrxMouse - on screen 0"
},
    "gestureInstructions1": {
    "message": "마우스 제스처를 사용하여 아래로 스크롤",
        "description": "gesture instructions on screen 1 of the game"
},
    "gameReference1": {
    "message": "*** 추적 시작하기 ***",
        "description": "reference to the mouse chase game on screen 1 of the game"
},
    "movementInstructions1": {
    "message": "화면 아무 위치에서나 마우스 <span class='yellow-text'>오른쪽 버튼</span>을 누르고 + 마우스를 <span class='yellow-text'>아래로</span> 살짝 드래그하고 + 내려 놓습니다",
        "description": "movement instructions on screen 1 of the game"
},
    "gestureInstructions2": {
    "message": "슈퍼 드래그 제스처를 사용하여 새 탭의 링크를 엽니다",
        "description": "gesture instructions on screen 2 of the game"
},
    "gameReference2": {
    "message": "몬스터로부터 도망치세요!!!",
        "description": "reference to the mouse chase game on screen 2 of the game"
},
    "movementInstructions2Part1": {
    "message": "이 링크 위에서 마우스 <span class='yellow-text'>왼쪽 버튼</span>을",
        "description": "movement instructions on screen 1 of the game - part 1 of the sentence"
},
    "movementInstructions2Part2": {
    "message": "<a class='blue-link' href='/the-mouse-chase-2' target='_blank'>누르고</a>",
        "description": "movement instructions on screen 1 of the game - part 2 of the sentence"
},
    "movementInstructions2Part3": {
    "message": " + <span class='yellow-text'>오른쪽</span>으로 살짝 드래그한 다음 + 내려 놓습니다",
        "description": "movement instructions on screen 1 of the game - part 3 of the sentence"
},
    "gestureInstructions3": {
    "message": "마우스 제스처를 이용하여 왼쪽 탭으로 이동합니다",
        "description": "gesture instructions on screen 3 of the game"
},
    "gameReference3": {
    "message": "돌아가세요! 공주가 위험합니다",
        "description": "reference to the mouse chase game on screen 3 of the game"
},
    "movementInstructions3": {
    "message": "화면의 아무 위치에나 <span class='yellow-text'>오른쪽 버튼</span>을 누르고 + 마우스를 <span class='yellow-text'>위로 그 다음 왼쪽</span>으로 살짝 드래그하고 + 내려 놓습니다",
        "description": "movement instructions on screen 3 of the game"
},
    "gestureInstructions4": {
    "message": "마우스 제스처를 사용하여 이 페이지 상단으로 스크롤합니다",
        "description": "gesture instructions on screen 4 of the game"
},
    "gameReference4": {
    "message": "공주에게 가기 위해 고양이를 물리치세요",
        "description": "reference to the mouse chase game on screen 4 of the game"
},
    "movementInstructions4": {
    "message": "화면의 아무 위치에나 <span class='yellow-text'>오른쪽 버튼</span>을 누르고 + 마우스를 <span class='yellow-text'>오른쪽으로 그 다음 위로</span> 살짝 드래그하고 + 내려 놓습니다",
        "description": "movement instructions on screen 4 of the game"
},
    "gestureInstructions5": {
    "message": "슈퍼 드래그 제스처를 사용하여 이미지를 저장합니다",
        "description": "gesture instructions on screen 5 of the game"
},
    "gameReference5": {
    "message": "성공하셨네요! 이제 공주를 구하세요",
        "description": "reference to the mouse chase game on screen 5 of the game"
},
    "movementInstructions5": {
    "message": "공주 이미지에서 마우스 <span class='yellow-text'>왼쪽 버튼</span>을 누르고 + 마우스를 <span class='yellow-text'>아래로</span> 살짝 드래그하고 + 내려 놓습니다",
        "description": "movement instructions on screen 5 of the game"
},
    "fifthFinishGame": {
    "message": "게임을 완료하려면 여기를 클릭",
        "description": "A CTA the user needs to click in order to finish the game."
},
    "sixthCongratulations": {
    "message": "<span class='white-text'>축하합니다!</span>",
        "description": "The last screen of the game when the user is congratualated for finishing the game."
},
    "sixthCrxChampion": {
    "message": "<br>CrxMouse 챔피언이 되셨습니다",
        "description": "When translating, try to find the corresponding phrase for the phrase - CrxMouse champion, without translating the word - CrxMouse."
},
    "soundOn": {
    "message": "소리 켜기",
        "description": "instructions next to the sound icon when it's off"
},
    "soundOff": {
    "message": "소리 끄기",
        "description": "instructions next to the sound icon when it's on"
},
    "hearts": {
    "message": "플레이하고 하트 받기",
        "description": "headline of hearts section"
},
    "firstExistPopuptitle": {
    "message": "아직 시작하지 마세요!",
        "description": "title of exit popup"
},
    "firstExistPopupSubtitle": {
    "message": "마우스 제스처 사용 방법을 알아볼 수 있는 기회입니다",
        "description": "subtitle of  of exit popup"
},
    "firstExistPopupSubSubtitle": {
    "message": "(사악한 고양이로부터 공주를 구하세요...)",
        "description": "sub-subtitle of  of exit popup"
},
    "firstExitPopupCTA1": {
    "message": "게임 시작",
        "description": "First CTA of first exit popup"
},
    "exitPopupsCTA2": {
    "message": "대신 튜토리얼 보기",
        "description": "Second CTA of the exit popups"
},
    "exitPopupsCTA3": {
    "message": "CrxMouse 설정으로 이동",
        "description": "Third CTA of the exit popups"
},
    "secondExistPopupCTA1": {
    "message": "게임 계속하기",
        "description": "subtitle of the second exit popup"
},
    "needHelpPopupTitle": {
    "message": "도움이 필요하세요?",
        "description": "Title of the 'need help' popup"
},
    "needHelpPopupSubtitle": {
    "message": "게임 플레이 보기",
        "description": "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
},
    "needHelpPopupClose": {
    "message": "닫기",
        "description": "Subtitle of the 'need help' popup that opens a video showing someone playing the game"
},
    "settingsIcon": {
    "message": "설정",
        "description": "text next to settings icon - appears in all screens"
},
    "secondExistPopupSubtitle": {
    "message": "$NUMBER$개의 제스처만 배우면 됩니다",
        "description": "subtitle of the second exit popup",
        "placeholders": {
        "number": {
            "content": "$1"
        }
    }
}
}
